module.exports = __webpack_public_path__ + "img/mile3m-m@1.8e9cafd0.jpg";